var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"language-selector"},[_c('ul',{staticClass:"lang-selector-list"},_vm._l((_vm.langs),function(lang){return _c('li',{key:`reality-language-${lang.key}`,on:{"click":function($event){return _vm.selectLang(lang.key)}}},[_c('button',{staticClass:"language-label font-FoundersGrotesk"},[_vm._v(" "+_vm._s(lang.label)+" ")])])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }